import React from 'react';

import { BillingInfo } from 'features/checkout/state/types';
import {
  RenderTextField,
  RenderTextFieldProps,
} from 'shared/components/RenderTextField/RenderTextField';

export const AddressField = (
  props: Omit<RenderTextFieldProps<BillingInfo>, 'name'> & {
    name: keyof BillingInfo;
  },
) => <RenderTextField<BillingInfo> {...props} />;
